import { getSectionHeadingPath } from '/src/utils/apiFunctions';
import httpClient from '/src/utils/httpClient';
import { pathTypes } from '/src/utils/sectionEnums';

const customSchemaPath = (blockId) => `api/faq-blocks/${blockId}/design/custom-schema`;

export function getFaqCustomSchemaApi(blockId) {
  return httpClient.get(customSchemaPath(blockId));
}

export function updateFaqCustomSchemaApi(blockId, schema) {
  return httpClient.put(customSchemaPath(blockId), { schema: schema ?? null });
}

export function generateFaqCustomSchemaApi(blockId, { prompt, imageUrls, save }) {
  return httpClient.post(`${customSchemaPath(blockId)}/generate`, {
    prompt: prompt ?? '',
    imageUrls: imageUrls ?? [],
    save: Boolean(save),
  });
}

export function updateFaqApiCall({
  id,
  profileId,
  isPathDesign,
  view,

  headingTitle,
  headingDescription,
  headingTextAlign,
  headingImage,
  headingDivider,

  sectionBorderColor,
  sectionIsBackground,
  sectionTextColor,
  sectionBackgroundColor,
  sectionOpacity,
  sectionMargin,
  sectionPadding,
  sectionIsFullWidth,
  sectionShadow,
  sectionShadowColor,
  sectionShadowBorderColor,
  sectionShape,
  sectionBackgroundType,
  sectionBackgroundImage,
  sectionGradientColor1,
  sectionGradientColor2,
  sectionGradientDirection,
  sectionGradientOffset,
  sectionBorder,

  itemShadow,
  itemShadowColor,
  itemShape,
  itemOpacity,
  itemBorder,
  itemBorderColor,
  itemTextColor,
  itemBackgroundColor,
}) {
  return httpClient.put(getSectionHeadingPath(pathTypes.faq, isPathDesign, id), {
    profileId,
    id,
    view,

    headingTitle,
    headingDescription,
    headingTextAlign,
    headingImage,
    headingDivider,

    sectionBorderColor,
    isSectionBackground: sectionIsBackground,
    sectionTextColor,
    sectionBackgroundColor,
    sectionOpacity,
    sectionMargin,
    sectionPadding,
    sectionIsFullWidth,
    sectionShadow,
    sectionShadowColor,
    sectionShadowBorderColor,
    sectionShape,
    sectionBackgroundType,
    sectionBackgroundImage,
    sectionGradientColor1,
    sectionGradientColor2,
    sectionGradientDirection,
    sectionGradientOffset,
    sectionBorder,

    itemShadow,
    itemShadowColor,
    itemShape,
    itemOpacity,
    itemBorder,
    itemBorderColor,
    itemTextColor,
    itemBackgroundColor,
  });
}
